import { DefaultTheme } from "styled-components"

export const theme: DefaultTheme = {
  colors: {
    green: {
      dark: "#012E17",
      medium: "#084F1B",
      light: "#2A7D35",
    },
    yellow: {
      medium: "#FDC300",
      light: "#FED402",
    },
    white: {
      main: "#FFF",
    },
    neutral: {
      grey: "#61676a"
    }
  },
  bp: {
    large: 1240,
    medium: 980,
    small: 580,
    xsmall: 420,
  },
}
